{
  "main": {
    "en": {
      "identity": {
        "language": "en"
      },
      "dates": {
        "timeZoneNames": {
          "hourFormat": "+HH:mm;-HH:mm",
          "gmtFormat": "GMT{0}",
          "gmtZeroFormat": "GMT",
          "regionFormat": "{0} Time",
          "regionFormat-type-daylight": "{0} Daylight Time",
          "regionFormat-type-standard": "{0} Standard Time",
          "fallbackFormat": "{1} ({0})",
          "zone": {
            "Pacific": {
              "Honolulu": {
                "_type": "zone",
                "short": {
                  "generic": "HST",
                  "standard": "HST",
                  "daylight": "HDT"
                }
              },
              "Easter": {
                "_type": "zone",
                "exemplarCity": "Easter Island"
              },
              "Truk": {
                "_type": "zone",
                "exemplarCity": "Chuuk"
              },
              "Ponape": {
                "_type": "zone",
                "exemplarCity": "Pohnpei"
              },
              "Norfolk": {
                "_type": "zone",
                "exemplarCity": "Norfolk Island"
              },
              "Wake": {
                "_type": "zone",
                "exemplarCity": "Wake Island"
              }
            },
            "Etc": {
              "UTC": {
                "_type": "zone",
                "long": {
                  "standard": "Coordinated Universal Time"
                },
                "short": {
                  "standard": "UTC"
                }
              },
              "Unknown": {
                "_type": "zone",
                "exemplarCity": "Unknown City"
              }
            },
            "Antarctica": {
              "DumontDUrville": {
                "_type": "zone",
                "exemplarCity": "Dumont-d’Urville"
              },
              "Macquarie": {
                "_type": "zone",
                "exemplarCity": "Macquarie Island"
              }
            },
            "Australia": {
              "Lord_Howe": {
                "_type": "zone",
                "exemplarCity": "Lord Howe Island"
              }
            },
            "America": {
              "St_Barthelemy": {
                "_type": "zone",
                "exemplarCity": "St. Barthélemy"
              },
              "Noronha": {
                "_type": "zone",
                "exemplarCity": "Fernando de Noronha"
              },
              "Coral_Harbour": {
                "_type": "zone",
                "exemplarCity": "Atikokan"
              },
              "St_Johns": {
                "_type": "zone",
                "exemplarCity": "St. John’s"
              },
              "Curacao": {
                "_type": "zone",
                "exemplarCity": "Curaçao"
              },
              "Godthab": {
                "_type": "zone",
                "exemplarCity": "Nuuk"
              },
              "Scoresbysund": {
                "_type": "zone",
                "exemplarCity": "Ittoqqortoormiit"
              },
              "St_Kitts": {
                "_type": "zone",
                "exemplarCity": "St. Kitts"
              },
              "St_Lucia": {
                "_type": "zone",
                "exemplarCity": "St. Lucia"
              },
              "Ciudad_Juarez": {
                "_type": "zone",
                "exemplarCity": "Ciudad Juárez"
              },
              "Bahia_Banderas": {
                "_type": "zone",
                "exemplarCity": "Bahía de Banderas"
              },
              "Merida": {
                "_type": "zone",
                "exemplarCity": "Mérida"
              },
              "Cancun": {
                "_type": "zone",
                "exemplarCity": "Cancún"
              },
              "Asuncion": {
                "_type": "zone",
                "exemplarCity": "Asunción"
              },
              "Lower_Princes": {
                "_type": "zone",
                "exemplarCity": "Lower Prince’s Quarter"
              },
              "North_Dakota": {
                "Beulah": {
                  "_type": "zone",
                  "exemplarCity": "Beulah, North Dakota"
                },
                "New_Salem": {
                  "_type": "zone",
                  "exemplarCity": "New Salem, North Dakota"
                },
                "Center": {
                  "_type": "zone",
                  "exemplarCity": "Center, North Dakota"
                }
              },
              "Indiana": {
                "Vincennes": {
                  "_type": "zone",
                  "exemplarCity": "Vincennes, Indiana"
                },
                "Petersburg": {
                  "_type": "zone",
                  "exemplarCity": "Petersburg, Indiana"
                },
                "Tell_City": {
                  "_type": "zone",
                  "exemplarCity": "Tell City, Indiana"
                },
                "Knox": {
                  "_type": "zone",
                  "exemplarCity": "Knox, Indiana"
                },
                "Winamac": {
                  "_type": "zone",
                  "exemplarCity": "Winamac, Indiana"
                },
                "Marengo": {
                  "_type": "zone",
                  "exemplarCity": "Marengo, Indiana"
                },
                "Vevay": {
                  "_type": "zone",
                  "exemplarCity": "Vevay, Indiana"
                }
              },
              "Kentucky": {
                "Monticello": {
                  "_type": "zone",
                  "exemplarCity": "Monticello, Kentucky"
                }
              },
              "St_Vincent": {
                "_type": "zone",
                "exemplarCity": "St. Vincent"
              },
              "St_Thomas": {
                "_type": "zone",
                "exemplarCity": "St. Thomas"
              }
            },
            "Indian": {
              "Cocos": {
                "_type": "zone",
                "exemplarCity": "Cocos Islands"
              },
              "Christmas": {
                "_type": "zone",
                "exemplarCity": "Christmas Island"
              },
              "Reunion": {
                "_type": "zone",
                "exemplarCity": "Réunion"
              }
            },
            "Africa": {
              "Asmera": {
                "_type": "zone",
                "exemplarCity": "Asmara"
              },
              "Sao_Tome": {
                "_type": "zone",
                "exemplarCity": "São Tomé"
              }
            },
            "Atlantic": {
              "Faeroe": {
                "_type": "zone",
                "exemplarCity": "Faroe"
              },
              "St_Helena": {
                "_type": "zone",
                "exemplarCity": "St. Helena"
              }
            },
            "Europe": {
              "London": {
                "_type": "zone",
                "long": {
                  "daylight": "British Summer Time"
                }
              },
              "Dublin": {
                "_type": "zone",
                "long": {
                  "daylight": "Irish Standard Time"
                }
              },
              "Kiev": {
                "_type": "zone",
                "exemplarCity": "Kyiv"
              }
            },
            "Asia": {
              "Calcutta": {
                "_type": "zone",
                "exemplarCity": "Kolkata"
              },
              "Qostanay": {
                "_type": "zone",
                "exemplarCity": "Kostanay"
              },
              "Rangoon": {
                "_type": "zone",
                "exemplarCity": "Yangon"
              },
              "Macau": {
                "_type": "zone",
                "exemplarCity": "Macao"
              },
              "Katmandu": {
                "_type": "zone",
                "exemplarCity": "Kathmandu"
              },
              "Saigon": {
                "_type": "zone",
                "exemplarCity": "Ho Chi Minh City"
              }
            }
          },
          "metazone": {
            "Acre": {
              "long": {
                "generic": "Acre Time",
                "standard": "Acre Standard Time",
                "daylight": "Acre Summer Time"
              }
            },
            "Afghanistan": {
              "long": {
                "standard": "Afghanistan Time"
              }
            },
            "Africa_Central": {
              "long": {
                "standard": "Central Africa Time"
              }
            },
            "Africa_Eastern": {
              "long": {
                "standard": "East Africa Time"
              }
            },
            "Africa_Southern": {
              "long": {
                "standard": "South Africa Standard Time"
              }
            },
            "Africa_Western": {
              "long": {
                "generic": "West Africa Time",
                "standard": "West Africa Standard Time",
                "daylight": "West Africa Summer Time"
              }
            },
            "Alaska": {
              "long": {
                "generic": "Alaska Time",
                "standard": "Alaska Standard Time",
                "daylight": "Alaska Daylight Time"
              },
              "short": {
                "generic": "AKT",
                "standard": "AKST",
                "daylight": "AKDT"
              }
            },
            "Almaty": {
              "long": {
                "generic": "Almaty Time",
                "standard": "Almaty Standard Time",
                "daylight": "Almaty Summer Time"
              }
            },
            "Amazon": {
              "long": {
                "generic": "Amazon Time",
                "standard": "Amazon Standard Time",
                "daylight": "Amazon Summer Time"
              }
            },
            "America_Central": {
              "long": {
                "generic": "Central Time",
                "standard": "Central Standard Time",
                "daylight": "Central Daylight Time"
              },
              "short": {
                "generic": "CT",
                "standard": "CST",
                "daylight": "CDT"
              }
            },
            "America_Eastern": {
              "long": {
                "generic": "Eastern Time",
                "standard": "Eastern Standard Time",
                "daylight": "Eastern Daylight Time"
              },
              "short": {
                "generic": "ET",
                "standard": "EST",
                "daylight": "EDT"
              }
            },
            "America_Mountain": {
              "long": {
                "generic": "Mountain Time",
                "standard": "Mountain Standard Time",
                "daylight": "Mountain Daylight Time"
              },
              "short": {
                "generic": "MT",
                "standard": "MST",
                "daylight": "MDT"
              }
            },
            "America_Pacific": {
              "long": {
                "generic": "Pacific Time",
                "standard": "Pacific Standard Time",
                "daylight": "Pacific Daylight Time"
              },
              "short": {
                "generic": "PT",
                "standard": "PST",
                "daylight": "PDT"
              }
            },
            "Anadyr": {
              "long": {
                "generic": "Anadyr Time",
                "standard": "Anadyr Standard Time",
                "daylight": "Anadyr Summer Time"
              }
            },
            "Apia": {
              "long": {
                "generic": "Samoa Time",
                "standard": "Samoa Standard Time",
                "daylight": "Samoa Daylight Time"
              }
            },
            "Aqtau": {
              "long": {
                "generic": "Aqtau Time",
                "standard": "Aqtau Standard Time",
                "daylight": "Aqtau Summer Time"
              }
            },
            "Aqtobe": {
              "long": {
                "generic": "Aqtobe Time",
                "standard": "Aqtobe Standard Time",
                "daylight": "Aqtobe Summer Time"
              }
            },
            "Arabian": {
              "long": {
                "generic": "Arabian Time",
                "standard": "Arabian Standard Time",
                "daylight": "Arabian Daylight Time"
              }
            },
            "Argentina": {
              "long": {
                "generic": "Argentina Time",
                "standard": "Argentina Standard Time",
                "daylight": "Argentina Summer Time"
              }
            },
            "Argentina_Western": {
              "long": {
                "generic": "Western Argentina Time",
                "standard": "Western Argentina Standard Time",
                "daylight": "Western Argentina Summer Time"
              }
            },
            "Armenia": {
              "long": {
                "generic": "Armenia Time",
                "standard": "Armenia Standard Time",
                "daylight": "Armenia Summer Time"
              }
            },
            "Atlantic": {
              "long": {
                "generic": "Atlantic Time",
                "standard": "Atlantic Standard Time",
                "daylight": "Atlantic Daylight Time"
              },
              "short": {
                "generic": "AT",
                "standard": "AST",
                "daylight": "ADT"
              }
            },
            "Australia_Central": {
              "long": {
                "generic": "Australian Central Time",
                "standard": "Australian Central Standard Time",
                "daylight": "Australian Central Daylight Time"
              }
            },
            "Australia_CentralWestern": {
              "long": {
                "generic": "Australian Central Western Time",
                "standard": "Australian Central Western Standard Time",
                "daylight": "Australian Central Western Daylight Time"
              }
            },
            "Australia_Eastern": {
              "long": {
                "generic": "Australian Eastern Time",
                "standard": "Australian Eastern Standard Time",
                "daylight": "Australian Eastern Daylight Time"
              }
            },
            "Australia_Western": {
              "long": {
                "generic": "Australian Western Time",
                "standard": "Australian Western Standard Time",
                "daylight": "Australian Western Daylight Time"
              }
            },
            "Azerbaijan": {
              "long": {
                "generic": "Azerbaijan Time",
                "standard": "Azerbaijan Standard Time",
                "daylight": "Azerbaijan Summer Time"
              }
            },
            "Azores": {
              "long": {
                "generic": "Azores Time",
                "standard": "Azores Standard Time",
                "daylight": "Azores Summer Time"
              }
            },
            "Bangladesh": {
              "long": {
                "generic": "Bangladesh Time",
                "standard": "Bangladesh Standard Time",
                "daylight": "Bangladesh Summer Time"
              }
            },
            "Bhutan": {
              "long": {
                "standard": "Bhutan Time"
              }
            },
            "Bolivia": {
              "long": {
                "standard": "Bolivia Time"
              }
            },
            "Brasilia": {
              "long": {
                "generic": "Brasilia Time",
                "standard": "Brasilia Standard Time",
                "daylight": "Brasilia Summer Time"
              }
            },
            "Brunei": {
              "long": {
                "standard": "Brunei Time"
              }
            },
            "Cape_Verde": {
              "long": {
                "generic": "Cape Verde Time",
                "standard": "Cape Verde Standard Time",
                "daylight": "Cape Verde Summer Time"
              }
            },
            "Casey": {
              "long": {
                "standard": "Casey Time"
              }
            },
            "Chamorro": {
              "long": {
                "standard": "Chamorro Standard Time"
              }
            },
            "Chatham": {
              "long": {
                "generic": "Chatham Time",
                "standard": "Chatham Standard Time",
                "daylight": "Chatham Daylight Time"
              }
            },
            "Chile": {
              "long": {
                "generic": "Chile Time",
                "standard": "Chile Standard Time",
                "daylight": "Chile Summer Time"
              }
            },
            "China": {
              "long": {
                "generic": "China Time",
                "standard": "China Standard Time",
                "daylight": "China Daylight Time"
              }
            },
            "Christmas": {
              "long": {
                "standard": "Christmas Island Time"
              }
            },
            "Cocos": {
              "long": {
                "standard": "Cocos Islands Time"
              }
            },
            "Colombia": {
              "long": {
                "generic": "Colombia Time",
                "standard": "Colombia Standard Time",
                "daylight": "Colombia Summer Time"
              }
            },
            "Cook": {
              "long": {
                "generic": "Cook Islands Time",
                "standard": "Cook Islands Standard Time",
                "daylight": "Cook Islands Summer Time"
              }
            },
            "Cuba": {
              "long": {
                "generic": "Cuba Time",
                "standard": "Cuba Standard Time",
                "daylight": "Cuba Daylight Time"
              }
            },
            "Davis": {
              "long": {
                "standard": "Davis Time"
              }
            },
            "DumontDUrville": {
              "long": {
                "standard": "Dumont d’Urville Time"
              }
            },
            "East_Timor": {
              "long": {
                "standard": "Timor-Leste Time"
              }
            },
            "Easter": {
              "long": {
                "generic": "Easter Island Time",
                "standard": "Easter Island Standard Time",
                "daylight": "Easter Island Summer Time"
              }
            },
            "Ecuador": {
              "long": {
                "standard": "Ecuador Time"
              }
            },
            "Europe_Central": {
              "long": {
                "generic": "Central European Time",
                "standard": "Central European Standard Time",
                "daylight": "Central European Summer Time"
              }
            },
            "Europe_Eastern": {
              "long": {
                "generic": "Eastern European Time",
                "standard": "Eastern European Standard Time",
                "daylight": "Eastern European Summer Time"
              }
            },
            "Europe_Further_Eastern": {
              "long": {
                "standard": "Further-eastern European Time"
              }
            },
            "Europe_Western": {
              "long": {
                "generic": "Western European Time",
                "standard": "Western European Standard Time",
                "daylight": "Western European Summer Time"
              }
            },
            "Falkland": {
              "long": {
                "generic": "Falkland Islands Time",
                "standard": "Falkland Islands Standard Time",
                "daylight": "Falkland Islands Summer Time"
              }
            },
            "Fiji": {
              "long": {
                "generic": "Fiji Time",
                "standard": "Fiji Standard Time",
                "daylight": "Fiji Summer Time"
              }
            },
            "French_Guiana": {
              "long": {
                "standard": "French Guiana Time"
              }
            },
            "French_Southern": {
              "long": {
                "standard": "French Southern & Antarctic Time"
              }
            },
            "Galapagos": {
              "long": {
                "standard": "Galapagos Time"
              }
            },
            "Gambier": {
              "long": {
                "standard": "Gambier Time"
              }
            },
            "Georgia": {
              "long": {
                "generic": "Georgia Time",
                "standard": "Georgia Standard Time",
                "daylight": "Georgia Summer Time"
              }
            },
            "Gilbert_Islands": {
              "long": {
                "standard": "Gilbert Islands Time"
              }
            },
            "GMT": {
              "long": {
                "standard": "Greenwich Mean Time"
              },
              "short": {
                "standard": "GMT"
              }
            },
            "Greenland": {
              "long": {
                "generic": "Greenland Time",
                "standard": "Greenland Standard Time",
                "daylight": "Greenland Summer Time"
              }
            },
            "Greenland_Eastern": {
              "long": {
                "generic": "East Greenland Time",
                "standard": "East Greenland Standard Time",
                "daylight": "East Greenland Summer Time"
              }
            },
            "Greenland_Western": {
              "long": {
                "generic": "West Greenland Time",
                "standard": "West Greenland Standard Time",
                "daylight": "West Greenland Summer Time"
              }
            },
            "Guam": {
              "long": {
                "standard": "Guam Standard Time"
              }
            },
            "Gulf": {
              "long": {
                "standard": "Gulf Standard Time"
              }
            },
            "Guyana": {
              "long": {
                "standard": "Guyana Time"
              }
            },
            "Hawaii_Aleutian": {
              "long": {
                "generic": "Hawaii-Aleutian Time",
                "standard": "Hawaii-Aleutian Standard Time",
                "daylight": "Hawaii-Aleutian Daylight Time"
              },
              "short": {
                "generic": "HAT",
                "standard": "HAST",
                "daylight": "HADT"
              }
            },
            "Hong_Kong": {
              "long": {
                "generic": "Hong Kong Time",
                "standard": "Hong Kong Standard Time",
                "daylight": "Hong Kong Summer Time"
              }
            },
            "Hovd": {
              "long": {
                "generic": "Hovd Time",
                "standard": "Hovd Standard Time",
                "daylight": "Hovd Summer Time"
              }
            },
            "India": {
              "long": {
                "standard": "India Standard Time"
              }
            },
            "Indian_Ocean": {
              "long": {
                "standard": "Indian Ocean Time"
              }
            },
            "Indochina": {
              "long": {
                "standard": "Indochina Time"
              }
            },
            "Indonesia_Central": {
              "long": {
                "standard": "Central Indonesia Time"
              }
            },
            "Indonesia_Eastern": {
              "long": {
                "standard": "Eastern Indonesia Time"
              }
            },
            "Indonesia_Western": {
              "long": {
                "standard": "Western Indonesia Time"
              }
            },
            "Iran": {
              "long": {
                "generic": "Iran Time",
                "standard": "Iran Standard Time",
                "daylight": "Iran Daylight Time"
              }
            },
            "Irkutsk": {
              "long": {
                "generic": "Irkutsk Time",
                "standard": "Irkutsk Standard Time",
                "daylight": "Irkutsk Summer Time"
              }
            },
            "Israel": {
              "long": {
                "generic": "Israel Time",
                "standard": "Israel Standard Time",
                "daylight": "Israel Daylight Time"
              }
            },
            "Japan": {
              "long": {
                "generic": "Japan Time",
                "standard": "Japan Standard Time",
                "daylight": "Japan Daylight Time"
              }
            },
            "Kamchatka": {
              "long": {
                "generic": "Kamchatka Time",
                "standard": "Kamchatka Standard Time",
                "daylight": "Kamchatka Summer Time"
              }
            },
            "Kazakhstan": {
              "long": {
                "standard": "Kazakhstan Time"
              }
            },
            "Kazakhstan_Eastern": {
              "long": {
                "standard": "East Kazakhstan Time"
              }
            },
            "Kazakhstan_Western": {
              "long": {
                "standard": "West Kazakhstan Time"
              }
            },
            "Korea": {
              "long": {
                "generic": "Korean Time",
                "standard": "Korean Standard Time",
                "daylight": "Korean Daylight Time"
              }
            },
            "Kosrae": {
              "long": {
                "standard": "Kosrae Time"
              }
            },
            "Krasnoyarsk": {
              "long": {
                "generic": "Krasnoyarsk Time",
                "standard": "Krasnoyarsk Standard Time",
                "daylight": "Krasnoyarsk Summer Time"
              }
            },
            "Kyrgystan": {
              "long": {
                "standard": "Kyrgyzstan Time"
              }
            },
            "Lanka": {
              "long": {
                "standard": "Lanka Time"
              }
            },
            "Line_Islands": {
              "long": {
                "standard": "Line Islands Time"
              }
            },
            "Lord_Howe": {
              "long": {
                "generic": "Lord Howe Time",
                "standard": "Lord Howe Standard Time",
                "daylight": "Lord Howe Daylight Time"
              }
            },
            "Macau": {
              "long": {
                "generic": "Macao Time",
                "standard": "Macao Standard Time",
                "daylight": "Macao Summer Time"
              }
            },
            "Magadan": {
              "long": {
                "generic": "Magadan Time",
                "standard": "Magadan Standard Time",
                "daylight": "Magadan Summer Time"
              }
            },
            "Malaysia": {
              "long": {
                "standard": "Malaysia Time"
              }
            },
            "Maldives": {
              "long": {
                "standard": "Maldives Time"
              }
            },
            "Marquesas": {
              "long": {
                "standard": "Marquesas Time"
              }
            },
            "Marshall_Islands": {
              "long": {
                "standard": "Marshall Islands Time"
              }
            },
            "Mauritius": {
              "long": {
                "generic": "Mauritius Time",
                "standard": "Mauritius Standard Time",
                "daylight": "Mauritius Summer Time"
              }
            },
            "Mawson": {
              "long": {
                "standard": "Mawson Time"
              }
            },
            "Mexico_Pacific": {
              "long": {
                "generic": "Mexican Pacific Time",
                "standard": "Mexican Pacific Standard Time",
                "daylight": "Mexican Pacific Daylight Time"
              }
            },
            "Mongolia": {
              "long": {
                "generic": "Ulaanbaatar Time",
                "standard": "Ulaanbaatar Standard Time",
                "daylight": "Ulaanbaatar Summer Time"
              }
            },
            "Moscow": {
              "long": {
                "generic": "Moscow Time",
                "standard": "Moscow Standard Time",
                "daylight": "Moscow Summer Time"
              }
            },
            "Myanmar": {
              "long": {
                "standard": "Myanmar Time"
              }
            },
            "Nauru": {
              "long": {
                "standard": "Nauru Time"
              }
            },
            "Nepal": {
              "long": {
                "standard": "Nepal Time"
              }
            },
            "New_Caledonia": {
              "long": {
                "generic": "New Caledonia Time",
                "standard": "New Caledonia Standard Time",
                "daylight": "New Caledonia Summer Time"
              }
            },
            "New_Zealand": {
              "long": {
                "generic": "New Zealand Time",
                "standard": "New Zealand Standard Time",
                "daylight": "New Zealand Daylight Time"
              }
            },
            "Newfoundland": {
              "long": {
                "generic": "Newfoundland Time",
                "standard": "Newfoundland Standard Time",
                "daylight": "Newfoundland Daylight Time"
              }
            },
            "Niue": {
              "long": {
                "standard": "Niue Time"
              }
            },
            "Norfolk": {
              "long": {
                "generic": "Norfolk Island Time",
                "standard": "Norfolk Island Standard Time",
                "daylight": "Norfolk Island Daylight Time"
              }
            },
            "Noronha": {
              "long": {
                "generic": "Fernando de Noronha Time",
                "standard": "Fernando de Noronha Standard Time",
                "daylight": "Fernando de Noronha Summer Time"
              }
            },
            "North_Mariana": {
              "long": {
                "standard": "Northern Mariana Islands Time"
              }
            },
            "Novosibirsk": {
              "long": {
                "generic": "Novosibirsk Time",
                "standard": "Novosibirsk Standard Time",
                "daylight": "Novosibirsk Summer Time"
              }
            },
            "Omsk": {
              "long": {
                "generic": "Omsk Time",
                "standard": "Omsk Standard Time",
                "daylight": "Omsk Summer Time"
              }
            },
            "Pakistan": {
              "long": {
                "generic": "Pakistan Time",
                "standard": "Pakistan Standard Time",
                "daylight": "Pakistan Summer Time"
              }
            },
            "Palau": {
              "long": {
                "standard": "Palau Time"
              }
            },
            "Papua_New_Guinea": {
              "long": {
                "standard": "Papua New Guinea Time"
              }
            },
            "Paraguay": {
              "long": {
                "generic": "Paraguay Time",
                "standard": "Paraguay Standard Time",
                "daylight": "Paraguay Summer Time"
              }
            },
            "Peru": {
              "long": {
                "generic": "Peru Time",
                "standard": "Peru Standard Time",
                "daylight": "Peru Summer Time"
              }
            },
            "Philippines": {
              "long": {
                "generic": "Philippine Time",
                "standard": "Philippine Standard Time",
                "daylight": "Philippine Summer Time"
              }
            },
            "Phoenix_Islands": {
              "long": {
                "standard": "Phoenix Islands Time"
              }
            },
            "Pierre_Miquelon": {
              "long": {
                "generic": "St. Pierre & Miquelon Time",
                "standard": "St. Pierre & Miquelon Standard Time",
                "daylight": "St. Pierre & Miquelon Daylight Time"
              }
            },
            "Pitcairn": {
              "long": {
                "standard": "Pitcairn Time"
              }
            },
            "Ponape": {
              "long": {
                "standard": "Pohnpei Time"
              }
            },
            "Pyongyang": {
              "long": {
                "standard": "North Korea Time"
              }
            },
            "Qyzylorda": {
              "long": {
                "generic": "Qyzylorda Time",
                "standard": "Qyzylorda Standard Time",
                "daylight": "Qyzylorda Summer Time"
              }
            },
            "Reunion": {
              "long": {
                "standard": "Réunion Time"
              }
            },
            "Rothera": {
              "long": {
                "standard": "Rothera Time"
              }
            },
            "Sakhalin": {
              "long": {
                "generic": "Sakhalin Time",
                "standard": "Sakhalin Standard Time",
                "daylight": "Sakhalin Summer Time"
              }
            },
            "Samara": {
              "long": {
                "generic": "Samara Time",
                "standard": "Samara Standard Time",
                "daylight": "Samara Summer Time"
              }
            },
            "Samoa": {
              "long": {
                "generic": "American Samoa Time",
                "standard": "American Samoa Standard Time",
                "daylight": "American Samoa Daylight Time"
              }
            },
            "Seychelles": {
              "long": {
                "standard": "Seychelles Time"
              }
            },
            "Singapore": {
              "long": {
                "standard": "Singapore Standard Time"
              }
            },
            "Solomon": {
              "long": {
                "standard": "Solomon Islands Time"
              }
            },
            "South_Georgia": {
              "long": {
                "standard": "South Georgia Time"
              }
            },
            "Suriname": {
              "long": {
                "standard": "Suriname Time"
              }
            },
            "Syowa": {
              "long": {
                "standard": "Syowa Time"
              }
            },
            "Tahiti": {
              "long": {
                "standard": "Tahiti Time"
              }
            },
            "Taipei": {
              "long": {
                "generic": "Taiwan Time",
                "standard": "Taiwan Standard Time",
                "daylight": "Taiwan Daylight Time"
              }
            },
            "Tajikistan": {
              "long": {
                "standard": "Tajikistan Time"
              }
            },
            "Tokelau": {
              "long": {
                "standard": "Tokelau Time"
              }
            },
            "Tonga": {
              "long": {
                "generic": "Tonga Time",
                "standard": "Tonga Standard Time",
                "daylight": "Tonga Summer Time"
              }
            },
            "Truk": {
              "long": {
                "standard": "Chuuk Time"
              }
            },
            "Turkmenistan": {
              "long": {
                "generic": "Turkmenistan Time",
                "standard": "Turkmenistan Standard Time",
                "daylight": "Turkmenistan Summer Time"
              }
            },
            "Tuvalu": {
              "long": {
                "standard": "Tuvalu Time"
              }
            },
            "Uruguay": {
              "long": {
                "generic": "Uruguay Time",
                "standard": "Uruguay Standard Time",
                "daylight": "Uruguay Summer Time"
              }
            },
            "Uzbekistan": {
              "long": {
                "generic": "Uzbekistan Time",
                "standard": "Uzbekistan Standard Time",
                "daylight": "Uzbekistan Summer Time"
              }
            },
            "Vanuatu": {
              "long": {
                "generic": "Vanuatu Time",
                "standard": "Vanuatu Standard Time",
                "daylight": "Vanuatu Summer Time"
              }
            },
            "Venezuela": {
              "long": {
                "standard": "Venezuela Time"
              }
            },
            "Vladivostok": {
              "long": {
                "generic": "Vladivostok Time",
                "standard": "Vladivostok Standard Time",
                "daylight": "Vladivostok Summer Time"
              }
            },
            "Volgograd": {
              "long": {
                "generic": "Volgograd Time",
                "standard": "Volgograd Standard Time",
                "daylight": "Volgograd Summer Time"
              }
            },
            "Vostok": {
              "long": {
                "standard": "Vostok Time"
              }
            },
            "Wake": {
              "long": {
                "standard": "Wake Island Time"
              }
            },
            "Wallis": {
              "long": {
                "standard": "Wallis & Futuna Time"
              }
            },
            "Yakutsk": {
              "long": {
                "generic": "Yakutsk Time",
                "standard": "Yakutsk Standard Time",
                "daylight": "Yakutsk Summer Time"
              }
            },
            "Yekaterinburg": {
              "long": {
                "generic": "Yekaterinburg Time",
                "standard": "Yekaterinburg Standard Time",
                "daylight": "Yekaterinburg Summer Time"
              }
            },
            "Yukon": {
              "long": {
                "standard": "Yukon Time"
              }
            }
          }
        }
      }
    }
  }
}
